var RootVariable = {
  SELECT_ITEM_HOVER_BG: '--gui-select-item-hover-bg',
  SELECT_ITEM_HOVER_COLOR: '--gui-select-item-hover-color',
  SELECT_ITEM_SELECTED_BG: '--gui-select-item-selected-bg',
  SELECT_ITEM_SELECTED_COLOR: '--gui-select-item-selected-color',
  SELECT_ITEM_COLOR: '--gui-select-item-color',
  SELECT_ITEM_FONT_SIZE: '--gui-select-item-font-size',
  SELECT_ITEM_FONT_WEIGHT: '--gui-select-item-font-weight',
  SELECT_ITEM_HEIGHT: '--gui-select-item-h',
  SELECT_ITEM_RADIUS: '--gui-select-item-radius',
  SELECT_ITEM_BASE_PADDING: '--gui-select-item-base-padding',
  SELECT_ITEM_COL_GAP: '--gui-select-item-col-gap',
  SELECT_ITEM_ACTIVE_ICON_SAFE_GAP: '--gui-select-item-active-icon-safe-gap',
  SELECT_ITEM_ACTIVE_ICON_SIZE: '--gui-select-item-active-icon-size',
  SELECT_BASE_PADDING: '--gui-select-base-padding',
  SELECT_FONT_SIZE: '--gui-select-font-size',
  SELECT_FONT_WEIGHT: '--gui-select-font-weight',
  SELECT_RADIUS: '--gui-select-radius',
  SELECT_BORDER_WIDTH: '--gui-select-border-width',
  SELECT_BORDER_COLOR: '--gui-select-border-color',
  SELECT_HEIGHT: '--gui-select-h',
  SELECT_BG: '--gui-select-bg',
  SELECT_COLOR: '--gui-select-color',
  SELECT_FOCUS_BORDER_COLOR: '--gui-select-focus-border-color',
  SELECT_FOCUS_BG: '--gui-select-focus-bg',
  SELECT_FOCUS_COLOR: '--gui-select-focus-color',
  SELECT_ACTIVE_BORDER_COLOR: '--gui-select-active-border-color',
  SELECT_ACTIVE_BG: '--gui-select-active-bg',
  SELECT_ACTIVE_COLOR: '--gui-select-active-color',
  SELECT_HOVER_BORDER_COLOR: '--gui-select-hover-border-color',
  SELECT_HOVER_BG: '--gui-select-hover-bg',
  SELECT_HOVER_COLOR: '--gui-select-hover-color',
  SELECT_DISABLED_BORDER_COLOR: '--gui-select-disabled-border-color',
  SELECT_DISABLED_BG: '--gui-select-disabled-bg',
  SELECT_DISABLED_COLOR: '--gui-select-disabled-color',
  SELECT_INVALID_BORDER_COLOR: '--gui-select-invalid-border-color',
  SELECT_INVALID_BG: '--gui-select-invalid-bg',
  SELECT_INVALID_COLOR: '--gui-select-invalid-color',
  SELECT_DROPDOWN_BG: '--gui-select-dropdown-bg',
  SELECT_DROPDOWN_RADIUS: '--gui-select-dropdown-radius',
  SELECT_DROPDOWN_PADDING: '--gui-select-dropdown-padding',
  SELECT_DROPDOWN_BOTTOM_SAFE_GAP: '--gui-select-dropdown-bottom-safe-gap',
  SELECT_PLACEHOLDER_FONT_SIZE: '--gui-select-placeholder-font-size',
  SELECT_PLACEHOLDER_FONT_WEIGHT: '--gui-select-placeholder-font-weight',
  SELECT_PLACEHOLDER_COLOR: '--gui-select-placeholder-color',
  SELECT_DISABLED_PLACEHOLDER_COLOR: '--gui-select-disabled-placeholder-color',
  SELECT_INVALID_PLACEHOLDER_COLOR: '--gui-select-invalid-placeholder-color',
  SELECT_ICON_COLOR: '--gui-select-icon-color',
  SELECT_ICON_SAFE_GAP: '--gui-select-icon-safe-gap',
  SELECT_ICON_SIZE: '--gui-select-icon-size',
  SELECT_DISABLED_ICON_COLOR: '--gui-select-disabled-icon-color',
  SELECT_CLEAR_ICON_SIZE: '--gui-select-clear-icon-size',
  SELECT_CLEAR_ICON_COLOR: '--gui-select-clear-icon-color',
  SELECT_RIGHT_SECTION_SAFE_GAP: '--gui-select-rightSection-safe-gap',
  SELECT_RIGHT_SECTION_ICON_SIZE: '--gui-select-rightSection-icon-size',
  SELECT_RIGHT_SECTION_COLOR: '--gui-select-rightSection-color',
  SELECT_HOVER_RIGHT_SECTION_COLOR: '--gui-select-hover-rightSection-color',
  SELECT_ACTIVE_RIGHT_SECTION_COLOR: '--gui-select-active-rightSection-color',
  SELECT_DISABLED_RIGHT_SECTION_COLOR: '--gui-select-disabled-rightSection-color'
};
var MultiSelectRootVariable = {
  MULTI_SELECT_VALUE_HEIGHT: '--gui-multi-select-value-height',
  MULTI_SELECT_VALUE_FONT_SIZE: '--gui-multi-select-font-size',
  MULTI_SELECT_VALUE_FONT_WEIGHT: '--gui-multi-select-font-weight',
  MULTI_SELECT_VALUE_COLOR: '--gui-multi-select-color',
  MULTI_SELECT_VALUE_BG: '--gui-multi-select-bg',
  MULTI_SELECT_VALUE_PADDING: '--gui-multi-select-padding',
  MULTI_SELECT_VALUE_RADIUS: '--gui-multi-select-radius',
  MULTI_SELECT_VALUES_VERTICAL_PADDING: '--gui-multi-select-vertical-padding',
  MULTI_SELECT_INPUT_TRANSFORM_OFFSET: '--gui-multi-select-transform-offset'
};

export { MultiSelectRootVariable, RootVariable };
//# sourceMappingURL=constant.js.map
